import leumiBank from "./banksFlows/leumiBank";
import hapoalimBank from "./banksFlows/HapoalimBank";
import discountBank from "./banksFlows/discountBank";
import mizrahiBank from "./banksFlows/mizrahiBank";
import otsarHayalBank from "./banksFlows/otsarHayalBank";

export const banks = [hapoalimBank, leumiBank, discountBank, mizrahiBank, otsarHayalBank];
